import { ERROR_CODE_ASSET_LOADING, ERROR_UPC_ERROR, ERROR_CODE_VALIDATION, } from './errors';
/**
 * This locale is used to display translation keys instead of actual translations, for testing purposes.
 */
export const LOCALE_DISPLAY_KEYS = 'lu-XO';
// Accessibility
export const TR_ACCESSIBILITY_BACK = 'accessibility.back';
export const TR_ACCESSIBILITY_TOOLTIP = 'accessibility.tooltip';
export const TR_ACCESSIBILITY_NEXT = 'accessibility.next';
export const TR_ACCESSIBILITY_BUTTON_MOVE_DOWN = 'accessibility.moveDown_button';
export const TR_ACCESSIBILITY_BUTTON_MOVE_LEFT = 'accessibility.moveLeft_button';
export const TR_ACCESSIBILITY_BUTTON_MOVE_RIGHT = 'accessibility.moveRight_button';
export const TR_ACCESSIBILITY_BUTTON_MOVE_UP = 'accessibility.moveUp_button';
export const TR_ACCESSIBILITY_BUTTON_ROTATE_DOWN = 'accessibility.rotateDown_button';
export const TR_ACCESSIBILITY_BUTTON_ROTATE_LEFT = 'accessibility.rotateLeft_button';
export const TR_ACCESSIBILITY_BUTTON_ROTATE_RIGHT = 'accessibility.rotateRight_button';
export const TR_ACCESSIBILITY_BUTTON_ROTATE_UP = 'accessibility.rotateUp_button';
export const TR_ACCESSIBILITY_BUTTON_ZOOM_IN = 'accessibility.zoomIn_button';
export const TR_ACCESSIBILITY_BUTTON_ZOOM_OUT = 'accessibility.zoomOut_button';
// Carousel
export const TR_CAROUSEL_COLORS = 'carousel.colors';
export const TR_CAROUSEL_TRANSITIONS = 'carousel.transitions';
export const TR_CAROUSEL_TOOLTIP = 'carousel.tooltip';
export const TR_CAROUSEL_CLOSE = 'carousel.close';
export const TR_CAROUSEL_TRANSITIONS_BAR = 'carousel.transitions_bar';
// Device rotation
export const TR_DEVICE_ROTATION_MESSAGE = 'devicerotation.message';
// Errors
export const TR_ERROR_CODE_TITLE = {
    [ERROR_CODE_ASSET_LOADING]: `error.ASSET_LOADING_FAILED`,
    [ERROR_UPC_ERROR]: `error.UPC_NOT_AVAILABLE`,
    [ERROR_CODE_VALIDATION]: `error.VALIDATION_FAILED`,
};
export const TR_ERROR_CODE_BUTTON = {
    [ERROR_CODE_ASSET_LOADING]: `error.ASSET_LOADING_FAILED_BUTTON`,
    [ERROR_UPC_ERROR]: `error.UPC_NOT_AVAILABLE_BUTTON`,
    [ERROR_CODE_VALIDATION]: `error.VALIDATION_FAILED_BUTTON`,
};
// Explosion
export const TR_EXPLOSION_TOOLTIP = 'explosion.tooltip';
// Overlay
export const TR_OVERLAY_TOOLTIP = 'overlay.tooltip_v2';
export const TR_OVERLAY_CLOSE = 'overlay.close';
export const TR_BANNER_TITLE = 'banner.title';
// Tutorial
export const TR_TUTORIAL_PAUSE = 'tutorial.pause';
export const TR_TUTORIAL_PLAY = 'tutorial.play';
export const TR_TUTORIAL_CLOSE = 'tutorial.close_v2';
export const TR_TUTORIAL_TOOLTIP = 'tutorial.tooltip';
export const TR_TUTORIAL_DESCRIPTION_LONG_TAP = 'tutorial.desktop_longTap_description';
export const TR_TUTORIAL_DESCRIPTION_PANNING = 'tutorial.desktop_panning_description';
export const TR_TUTORIAL_DESCRIPTION_PINCH = 'tutorial.desktop_pinch_description';
export const TR_TUTORIAL_DESCRIPTION_ROTATE = 'tutorial.desktop_rotate_description';
export const TR_TUTORIAL_DESCRIPTION_TOUCH_LONG_TAP = 'tutorial.mobile_longTap_description_v2';
export const TR_TUTORIAL_DESCRIPTION_TOUCH_PANNING = 'tutorial.mobile_panning_description_v2';
export const TR_TUTORIAL_DESCRIPTION_TOUCH_PINCH = 'tutorial.mobile_pinch_description_v2';
export const TR_TUTORIAL_DESCRIPTION_TOUCH_ROTATE = 'tutorial.mobile_rotate_description_v2';
export const TR_TUTORIAL_STEP_TITLE_LONG_TAP = 'tutorial.longTap_step_title';
export const TR_TUTORIAL_STEP_TITLE_PANNING = 'tutorial.panning_step_title';
export const TR_TUTORIAL_STEP_TITLE_PINCH = 'tutorial.pinch_step_title';
export const TR_TUTORIAL_STEP_TITLE_ROTATE = 'tutorial.rotate_step_title';
